export default {
  buttons: {
    next: "Weiter",
    prev: "Zurück",
    skip: "Überspringen",
    done: "Fertig",
    gotIt: "Verstanden",
  },
  messages: {
    dontShowAgainLabel: "Nicht wieder anzeigen",
    stepNumbersOfLabel: "von",
  },
};
